<script setup>
import { useAppLoader } from '@/composables/useAppLoader';

defineOptions({ render: () => null });

const props = defineProps({
	visible: { type: Boolean, default: false },
});

useAppLoader(() => props.visible);
</script>
